document.addEventListener('DOMContentLoaded', function(){

  // Boot stamp intro — only plays once per browser session, not on every page nav
  var boot = document.getElementById('boot');
  if(boot){
    var alreadyShown = false;
    try { alreadyShown = sessionStorage.getItem('sw_boot_shown') === '1'; } catch(e){}
    if(alreadyShown){
      boot.classList.add('no-anim');
      boot.classList.add('hide');
    } else {
      window.addEventListener('load', function(){
        setTimeout(function(){
          boot.classList.add('hide');
          try { sessionStorage.setItem('sw_boot_shown', '1'); } catch(e){}
        }, 800);
      });
    }
  }

  // Mobile drawer
  var drawer = document.getElementById('drawer');
  var drawerOverlay = document.getElementById('drawerOverlay');
  var hamburgerBtn = document.getElementById('hamburgerBtn');
  var drawerClose = document.getElementById('drawerClose');
  function closeDrawer(){ if(drawer) drawer.classList.remove('open'); if(drawerOverlay) drawerOverlay.classList.remove('open'); }
  if(hamburgerBtn) hamburgerBtn.addEventListener('click', function(){ drawer.classList.add('open'); drawerOverlay.classList.add('open'); });
  if(drawerClose) drawerClose.addEventListener('click', closeDrawer);
  if(drawerOverlay) drawerOverlay.addEventListener('click', closeDrawer);

  // Scroll reveal — robust version that also catches elements added later
  // by Shopify's theme editor (which swaps section HTML via AJAX without a
  // full page reload, so a one-time querySelectorAll would miss new blocks).
  var revealIO = null;
  if('IntersectionObserver' in window){
    revealIO = new IntersectionObserver(function(entries){
      entries.forEach(function(e, i){
        if(e.isIntersecting){
          setTimeout(function(){ e.target.classList.add('in'); }, i * 70);
          revealIO.unobserve(e.target);
        }
      });
    }, {threshold:0.12});
  }
  function bindReveal(root){
    var scope = root || document;
    var els = scope.matches && scope.matches('.reveal, .reveal-up') ? [scope] : [];
    if(scope.querySelectorAll) els = els.concat(Array.prototype.slice.call(scope.querySelectorAll('.reveal, .reveal-up')));
    els.forEach(function(el){
      if(el.dataset.revealBound) return;
      el.dataset.revealBound = '1';
      if(revealIO){
        revealIO.observe(el);
      } else {
        el.classList.add('in');
      }
    });
  }
  bindReveal(document);

  // Watch for content Shopify injects later (theme editor block add/edit,
  // AJAX section re-renders) and bind reveal behavior to it too.
  if('MutationObserver' in window){
    var mo = new MutationObserver(function(mutations){
      mutations.forEach(function(m){
        m.addedNodes.forEach(function(node){
          if(node.nodeType === 1) bindReveal(node);
        });
      });
    });
    mo.observe(document.body, {childList:true, subtree:true});
  }

  // Shopify theme editor fires this when a section is added/edited live —
  // make sure anything inside it is revealed immediately (editor previews
  // shouldn't rely on scroll position).
  document.addEventListener('shopify:section:load', function(e){
    bindReveal(e.target);
    e.target.querySelectorAll('.reveal, .reveal-up').forEach(function(el){ el.classList.add('in'); });
  });
  document.addEventListener('shopify:block:select', function(e){
    var el = e.target.closest ? e.target.closest('.reveal, .reveal-up') : null;
    if(el) el.classList.add('in');
  });

  // Animated counters
  var counters = document.querySelectorAll('.counter');
  if(counters.length && 'IntersectionObserver' in window){
    var counterIO = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){
          var el = e.target;
          var target = parseInt(el.dataset.target, 10);
          var cur = 0;
          var step = Math.max(1, Math.round(target/40));
          var iv = setInterval(function(){
            cur += step;
            if(cur >= target){ cur = target; clearInterval(iv); }
            el.textContent = cur.toLocaleString() + (target >= 1000 ? '+' : '');
          }, 30);
          counterIO.unobserve(el);
        }
      });
    }, {threshold:0.5});
    counters.forEach(function(c){ counterIO.observe(c); });
  }

  // Parallax on hero visual strip
  var panels = document.querySelectorAll('.hv-panel svg');
  window.addEventListener('scroll', function(){
    var y = window.scrollY;
    panels.forEach(function(svg, i){
      var depth = 0.06 + (i % 3) * 0.05;
      svg.style.transform = 'translate(-50%, calc(-50% + ' + (y * depth * 0.12) + 'px))';
    });
  }, {passive:true});

  // Product gallery thumbs
  document.querySelectorAll('.pd-thumb').forEach(function(thumb){
    thumb.addEventListener('click', function(){
      document.querySelectorAll('.pd-thumb').forEach(function(t){ t.classList.remove('active'); });
      thumb.classList.add('active');
      var mainImg = document.getElementById('pdMainImage');
      if(mainImg && thumb.dataset.fullsrc) mainImg.src = thumb.dataset.fullsrc;
    });
  });

  // Variant selection: sync option dropdowns -> hidden id field, main image, price
  var pdVariantDataEl = document.getElementById('pdVariantData');
  if(pdVariantDataEl){
    var pdVariants = JSON.parse(pdVariantDataEl.textContent);
    var pdOptionSelects = document.querySelectorAll('.pd-select');
    var pdHiddenId = document.querySelector('select[name="id"]');
    var pdMainImg = document.getElementById('pdMainImage');
    var pdPriceNow = document.querySelector('.pd-price-now');
    var pdPriceOld = document.querySelector('.pd-price-old');
    var pdAddBtn = document.querySelector('.pd-add-cart-btn');

    function pdFormatMoney(cents){
      return '$' + (cents / 100).toFixed(2);
    }

    function pdUpdateVariant(){
      var selected = Array.prototype.map.call(pdOptionSelects, function(s){ return s.value; });
      var match = pdVariants.filter(function(v){
        return v.options.length === selected.length && v.options.every(function(val, i){ return val === selected[i]; });
      })[0];
      if(!match) return;
      if(pdHiddenId) pdHiddenId.value = match.id;
      if(match.image && pdMainImg) pdMainImg.src = match.image;
      if(pdPriceNow) pdPriceNow.textContent = pdFormatMoney(match.price);
      if(pdPriceOld){
        if(match.compareAtPrice > match.price){
          pdPriceOld.textContent = pdFormatMoney(match.compareAtPrice);
          pdPriceOld.style.display = '';
        } else {
          pdPriceOld.style.display = 'none';
        }
      }
      if(pdAddBtn) pdAddBtn.dataset.variantId = match.id;
    }

    pdOptionSelects.forEach(function(s){ s.addEventListener('change', pdUpdateVariant); });
  }

  // Accordion
  document.querySelectorAll('.pd-acc-head').forEach(function(head){
    head.addEventListener('click', function(){
      var item = head.parentElement;
      var wasOpen = item.classList.contains('open');
      document.querySelectorAll('.pd-acc-item').forEach(function(i){ i.classList.remove('open'); });
      if(!wasOpen) item.classList.add('open');
    });
  });

  // Policy tabs (if present on page)
  document.querySelectorAll('.policy-tab').forEach(function(tab){
    tab.addEventListener('click', function(){
      document.querySelectorAll('.policy-tab').forEach(function(t){ t.classList.remove('active'); });
      document.querySelectorAll('.policy-section').forEach(function(s){ s.style.display = 'none'; });
      tab.classList.add('active');
      var target = document.getElementById(tab.dataset.target);
      if(target) target.style.display = 'block';
    });
  });

  // ===== AJAX Cart =====
  function addToCart(variantId, quantity, callback){
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity || 1 }] })
    })
    .then(function(res){ return res.json(); })
    .then(function(data){ updateCartCount(); if(callback) callback(data); })
    .catch(function(err){ console.error('Add to cart failed', err); });
  }

  function updateCartCount(){
    fetch(window.Shopify.routes.root + 'cart.js')
      .then(function(res){ return res.json(); })
      .then(function(cart){
        document.querySelectorAll('.cart-count').forEach(function(el){ el.textContent = cart.item_count; });
      });
  }

  var pdForm = document.getElementById('pdProductForm');
  if(pdForm){
    pdForm.addEventListener('submit', function(e){
      e.preventDefault();
      var variantId = pdForm.querySelector('[name="id"]').value;
      var qtyInput = pdForm.querySelector('[name="quantity"]');
      var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
      var btn = pdForm.querySelector('[type="submit"]');
      var originalText = btn.textContent;
      btn.textContent = 'Adding...';
      addToCart(variantId, qty, function(){
        btn.textContent = 'Added to Cart';
        setTimeout(function(){ btn.textContent = originalText; }, 1800);
      });
    });
  }

  document.querySelectorAll('[data-quick-add]').forEach(function(btn){
    btn.addEventListener('click', function(){
      var variantId = btn.dataset.quickAdd;
      btn.style.transform = 'rotate(90deg) scale(1.2)';
      setTimeout(function(){ btn.style.transform = ''; }, 300);
      addToCart(variantId, 1);
    });
  });

  updateCartCount();
});
